<template>
    <div class="video-wrap module-wrap" :id="target" v-if="video_valid" :data-log-content-ev="item.stat_flag" :data-spm="spm">
        <div class="video-mask" :style="bg_helper(item.imageUrl)" v-show="show_mask">
            <div class="play-btn" @click="playVideo">
                <!-- <i class="ico icon-ic_triangle"></i> -->
            </div>
            <div class="header-info">
                <h3 class="tt">{{item.title}}</h3>
            </div>
            
            <footer class="footer-info">
                <div class="play_count" v-if="play_num">
                    <i class="ico icon-eye"></i><em>{{play_num}}次播放</em>
                </div>
                <div class="duration" v-if="duration_time">
                    <span class="time">{{duration_time}}</span>
                </div>
            </footer>
        </div>
        <section class="relate_video" :class="target" ref="player_pos" v-if="!isMpVideo"></section>
    </div>
</template>
<script>
import NumberStr from '../_utils/number-str';
import VideoPlayer from 'mptcfe-wap-player';

export default {
    props: {
        target: {
            default: '',
            type: String
        },
        spm:{
            default: '',
            type: String
        },
        data: {
            default: {},
            type: [Array, Object]
        },
        findex: {
            default: '',
            type: [String, Number]
        }
    },
    data(){
        return {
            item: {},
            show_mask : true,
            sohu_player: null,
            player_ifr: null,
            video_valid: true,
            isMpVideo: false,
        }
    },
    mounted(){
        this.$nextTick(() => {
            let videoItem = document.getElementById(this.target);
            this.$emit('mounted', [ videoItem ]);
        })
    },
    methods: {
        bg_helper(url, type = 1){
            if(type == 1){
                return {
                    backgroundImage: `url('${url}')`,
                    backgroundSize: 'cover'
                }
            }else{
                return {
                    backgroundImage: `url('${url}')`,
                    backgroundSize: 'contain'
                }
            }
        },
        playVideo(){
            let that = this;
            if(this.item.type != 66) {
                this.show_mask = false;
            }
            if(this.item.type === 64){
                this.sohu_player && this.sohu_player.play();
            }else if(this.item.type === 10 || this.item.type === 65){
                that.player_ifr && that.$refs.player_pos.appendChild(that.player_ifr);
            }else if(this.item.type === 66) {
                const wrapper = document.querySelector('.mp-video-wrapper')
                const top = $(this.$el).offset().top
                let item = this.data[0] || {};
                window.mptcPlayer.play({
                    src: item.videoUrl.replace(/^http(s)?:/, ''),
                    params: {
                        newsId: item.articleId,
                        authorId: item.authId
                    }
                })
                if(wrapper.style.display == 'none') {
                    wrapper.style.display = 'block'
                }
                wrapper.style.top = top + 'px'
            }else {
                // console.warn("video type error");
            }
            // 埋点-视频点播事件
            if(window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode:3020
                });
            } 
        },
        initTv(cal){
            let subId = window.subData.id;
            let that = this, item = this.data[0] || {};
            let iframe, script;
            let unique_id = item.articleId || item.id;
            this.item = item;
            this.item.stat_flag = `m-${subId}_subvideos_${this.findex}`;
            let playerFactory = window.playerFactory
            if(item.type === 64){ //搜狐视频
                if(typeof playerFactory !== 'undefined'){
                    if(typeof playerFactory.createPlayer !== 'function'){
                        console.warn("load sohu-tv jssdk error");
                        return;
                    }
                    that.sohu_player = playerFactory.createPlayer(`.${that.target}`, {
                        data: {
                            vid: item.articleId,
                            site: item.site || 1
                        },
                        autoplay: false,
                        debug: false,
                        appid: 'tv',
                        mtvSrc: 10010001
                    });
                }
            }else if(item.type === 10 || item.type === 65){//搜狐直播
                that.player_ifr = that._create_ifr(item.link);
            }else if(item.type === 66 && item.videoUrl){//mp视频
                that.isMpVideo = true
                if(!window.mptcPlayer) {
                    const wrapper = document.createElement('div')
                    wrapper.className = 'mp-video-wrapper'
                    const container = document.createElement('div')
                    container.className = 'mp-video'
                    wrapper.appendChild(container)
                    $(".index-main").append(wrapper)
                    wrapper.style.display = 'none'
                    that.initMpVideo({
                        title: item.title,
                        playedNum: this.play_num,
                        duration: this.duration_time,
                        src: item.videoUrl.replace(/^http(s)?:/, ''),
                        poster: item.imageUrl,
                        titleShow: true,
                        infoShow: true
                    })
                }
            }else {
                console.warn("video param error");
            }
            
            if(!item.link){
                this.video_valid = false;
            }
            if(typeof cal === 'function') cal();
        },
        _create_ifr(link = ''){
            let ifr = document.createElement('iframe');
            ifr.width = '100%';
            ifr.height = '100%';
            ifr.frameborder = '0';
            ifr.scrolling = 'no';
            ifr.src = link;
            return ifr;
        },
        sec_to_time(s) {
            var t;
            if(s > -1){
                var hour = Math.floor(s/3600);
                var min = Math.floor(s/60) % 60;
                var sec = s % 60;
                if(hour < 10) {
                    t = '0'+ hour + ":";
                } else {
                    t = hour + ":";
                }

                if(min < 10){t += "0";}
                t += min + ":";
                if(sec < 10){t += "0";}
                t += sec.toFixed(0);
            }
            return t;
        },
        // 初始化视频播放器
        initMpVideo(opts) {
            const container = document.querySelector('.mp-video')
            window.mptcPlayer = new MptcPlayer(container, opts)
        }
    },
    mounted(){
        this.initTv();
    },
    updated(){
        this.$nextTick(() => {
            let videoItem = document.getElementById(this.target);
            this.$emit('mounted', [ videoItem ] );
        })
    },
    computed: {
        duration_time(){
            let duration;
            if(this.item.duration > 0){
                duration = this.item.duration;
                return this.sec_to_time(duration);
            }else{
                return '';
            }
        },
        play_num(){
            let play_count;
            if(this.item.tag > 0){
                play_count = this.item.tag;
                return new NumberStr(play_count).format();
            }else{
                return '';
            }
            
        }
    }
}
</script>
<style lang="less">
.video-wrap{
    position: relative;
    margin: 0 13px;
    height: 197px;
    padding: 10px 0;
    .video-mask{
        position: absolute;
        width: 100%;
        height: 197px;
        z-index: 99;
        background-repeat: no-repeat;
        background-position: center center;
        .play-btn{
            position: absolute;
            width: 54px;
            height: 54px;
            border-radius: 50%;
            background-color: rgba(0, 0, 0, .5);
            top: 0;bottom: 0;right: 0;left: 0;
            margin: auto;
            z-index: 100;
            background: url('../assets/images/ic_play_b.png') no-repeat center center;
            background-size: contain;
        }
        .header-info{
            padding: 10px 15px 10px 13px;
            background: linear-gradient(rgba(57, 57, 57, 0.85), rgba(0, 0, 0, 0));
            .tt{
                height: 46px;/*no*/
                font-size: 18px;/*no*/
                line-height: 1.3em;
                color: #fff;
                font-weight: bold;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                display: box;
                -webkit-box-orient: vertical;
            }
        }
        
        .footer-info{
            position: absolute;
            box-sizing: border-box;
            bottom: 0;
            width: 100%;
            height: 30px;
            background: linear-gradient(rgba(0, 0, 0, 0), rgba(57, 57, 57, 0.85));
            color: #fff;
            .play_count{
                position: absolute;
                left: 15px;
                bottom: 10px;
                display: flex;
                align-items: center;
                .ico{
                    font-size: 13px;/*no*/
                    margin-right: 2px;
                }
            }
            .duration{
                position: absolute;
                right: 15px;
                bottom: 10px;
            }
        }
    }
    .relate_video{
        position: relative;
        height: 197px;
    }
    
}
.mp-video-wrapper {
    position: absolute;
    box-sizing: border-box;
    padding: 10px 13px;
    width: 100%;
    height: 217px;
    z-index: 887;
    .mp-video {
        height: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/VVideo.vue